module.exports = __webpack_public_path__ + "assets/img/NPC006.22ac2d17.png";